import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";

const certFields = [
  { label: "Cert No.", key: "certNo" },
  { label: "ADM No.", key: "admNo" },
  { label: "REG No.", key: "regNo" },
  { label: "ROLL No.", key: "rollNo" },
];

const numberedFields = [
  { index: 1, label: "Name of the Pupil", key: "name" },
  { index: 2.1, label: "Mother's Name", key: "motherName" },
  { index: 2.2, label: "Father's Name", key: "fatherName" },
  { index: 3, label: "Nationality", key: "nationality" },
  { index: 4, label: "Date of Birth", key: "dob" },
  {
    index: 5,
    label: "Whether the candidate belongs to Schedule Caste or Schedule Tribe",
    key: "casteStatus",
  },
  {
    index: 6,
    label: "Date of first Admission in the school with class",
    key: "date_of_adm_class",
  },
  {
    index: 7,
    label: "Class in which the pupil last studied",
    key: "lastClass",
  },
  {
    index: 8,
    label: "School/Board Annual examination last taken with result",
    key: "lastExamResult",
  },
  {
    index: 9,
    label: "Whether failed, if so once/twice in the same class",
    key: "failHistory",
  },
  { index: 10, label: "Subject Studied", key: "subjects" },
  {
    index: 11,
    label: "Whether qualified for promotion to the higher class.",
    key: "qualified_for_promotion",
  },
  {
    index: 11.1,
    label: "If so, to which class",
    key: "promotionClass",
  },
  {
    index: 12,
    label: "Month up to which the (pupil has paid) school dues",
    key: "feesPaidTill",
  },
  {
    index: 13,
    label:
      "Any fee concession availed of: if so, the nature of such concession",
    key: "feeConcession",
  },
  { index: 14, label: "Total No. of working days", key: "totalWorkingDays" },
  { index: 15, label: "Total No. of present days", key: "totalPresentDays" },
  {
    index: 16,
    label: "Whether NCC Cadet/Boy Scout/Girl Guide (details may be given)",
    key: "nccDetails",
  },
  {
    index: 17,
    label:
      "Games played or extra-curricular activities (mention achievement level)",
    key: "activities",
  },
  { index: 18, label: "General Conduct", key: "conduct" },
  {
    index: 19,
    label: "Date of application for certificate",
    key: "applicationDate",
  },
  { index: 20, label: "Date of issue of certificate", key: "issueDate" },
  { index: 21, label: "Reason for leaving the school", key: "reasonLeaving" },
  { index: 22, label: "Any other remark", key: "remark" },
];

const Character_certificate_Form = (studentData, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        width: "210mm",
        minHeight: "297mm",
        p: 2,
        border: "2px solid black",
        boxSizing: "border-box",
        fontSize: "12px",
        fontFamily: "serif",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <style>
        {`@media print {
        @page {
          size: A4 portrait;
          margin: 10mm;
        }
      }`}
      </style>
      <Box>
        {/* Header */}
        <Box width="97%" bgcolor="grey.100" p={1.5}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <img
                src="/img/vpm_gns_logo.png"
                width={100}
                height={70}
                alt="School Logo"
              />
            </Grid>
            <Grid item xs textAlign="center" mr={4}>
              <Typography
                variant="h5"
                sx={{ fontFamily: "Alien Invader" }}
                fontSize={"2.5em"}
              >
                A.B.C Eduern Learning School
              </Typography>
              <Typography fontSize={"1.5em"}>
                Bairia, Daltonganj, Palamu - 822102 (Jharkhand)
              </Typography>
              <Typography variant="caption" fontSize={"1.2em"}>
                A Senior secondary (10+2), Affiliated to C.B.S.E, Delhi,
                Affiliation No. 3430175
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Certificate Title */}
        <Box
          display="flex"
          alignItems={"center"}
          justifyContent={"center"}
          width="100%"
          mt={5}
        >
          <Box
            sx={{
              border: "2px solid black",
              textAlign: "center",
              p: 1,
              mb: 2,
            }}
          >
            <Typography align="center" fontWeight="bold">
              CHARACTER CERTIFICATE
            </Typography>
          </Box>
        </Box>

        {/* Cert No. */}
        <Typography sx={{ mb: 7, fontWeight: "bold" }} fontSize="1.8em" mt={2}>
          Cert. No. {studentData.certNo || ""}
        </Typography>

        {/* Body */}
        <Typography sx={{ mb: 5, lineHeight: 2 }} fontSize="1.5em">
          This is to certify that Master/Miss{" "}
          <strong style={{ textTransform: "uppercase" }}>
            {studentData.name}
          </strong>{" "}
          Son/Daughter of{" "}
          <strong style={{ textTransform: "uppercase" }}>
            {studentData.motherName}
          </strong>{" "}
          and{" "}
          <strong style={{ textTransform: "uppercase" }}>
            {studentData.fatherName}
          </strong>
          , Admission No.{" "}
          <strong>
            {studentData?.admNo &&
              studentData?.admNo.toString().padStart(6, "0")}
          </strong>
          , Class{" "}
          <strong style={{ textTransform: "uppercase" }}>
            {studentData.lastClass}
          </strong>{" "}
          has been a bonafide student of this school from{" "}
          <strong>
            {studentData?.date_of_adm_class &&
              moment(
                studentData?.date_of_adm_class.split("/")[0],
                "DD-MM-YYYY"
              ).format("DD-MMM-YYYY")}
          </strong>{" "}
          to{" "}
          <strong>
            {studentData?.separationDate}
            {/* {studentData?.separationDate &&
              moment(studentData?.separationDate, "DD-MM-YYYY").format(
                "DD-MMM-YYYY"
              )} */}
          </strong>
          .
        </Typography>

        <Typography sx={{ mb: 4, lineHeight: 2 }} fontSize="1.5em">
          To the best of my knowledge he/she bears a Good moral character. I
          wish him/her every success in life.
        </Typography>
      </Box>

      <Box sx={{ mt: "auto" }}>
        {/* Footer Signature Row */}
        <Grid container sx={{ justifyContent: "space-between", mt: 5, mb: 5 }}>
          <Grid item>
            <Typography sx={{ fontWeight: "bold" }}>
              Date:{" "}
              {moment(studentData?.issueDate, "DD/MM/YYYY").format(
                "DD/MM/YYYY"
              )}
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ fontWeight: "bold" }}>Principal</Typography>
          </Grid>
        </Grid>

        {/* Bottom Line */}
        <Divider sx={{ borderColor: "black", my: 1 }} />
        <Grid container>
          <Grid item xs={4}>
            <Typography variant="caption">Website: www.testuser.com</Typography>
          </Grid>
          <Grid item xs={4} textAlign="center">
            <Typography variant="caption">Mobile No: 6983458745</Typography>
          </Grid>
          <Grid item xs={4} textAlign="right">
            <Typography variant="caption">
              Email: testuser3322@gmail.com
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const Character_certificate = React.forwardRef((props, tableRefs) => {
  const [studentData, setStudentData] = useState({});

  useEffect(() => {
    console.log("TC Form Loaded");
    console.log(props);
    if (props.data && Object.entries(props).length > 0)
      setStudentData(props.data);
  }, []);

  console.log(studentData);

  const jsxElementArray = Character_certificate_Form(studentData, tableRefs);

  return <>{jsxElementArray}</>;
});

export default Character_certificate;
